import { render, staticRenderFns } from "./PublishVideo.vue?vue&type=template&id=665273a1&scoped=true&"
import script from "./PublishVideo.vue?vue&type=script&lang=js&"
export * from "./PublishVideo.vue?vue&type=script&lang=js&"
import style0 from "./PublishVideo.vue?vue&type=style&index=0&id=665273a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665273a1",
  null
  
)

export default component.exports